export default "__VITE_PUBLIC_ASSET__d05d94be__"